import { Col } from "@commonlibs";
import clsx from "clsx";
import { ReactNode } from "react";
import FullLogo from "../../display/FullLogo/FullLogo";
import { BackgroundLayoutWithLogoRoot } from "./BackgroundLayoutWithLogo.styles";

interface BackgroundLayoutWithLogoProps {
    children?: ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function BackgroundLayoutWithLogo({ children, className, ...rest }: BackgroundLayoutWithLogoProps): JSX.Element {
    return (
        <BackgroundLayoutWithLogoRoot {...rest} className={clsx("background-layout-with-logo", className)}>
            <FullLogo color="white" link={false} />
            <Col flex={1} alignItems="center">
                {children}
            </Col>
        </BackgroundLayoutWithLogoRoot>
    );
}
